import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { buildUri, ROUTE, ROUTE_TITLE, tracker } from "../misc";
import { useCategory } from "../hooks";
import { useProviderComparePage } from "./useProviderComparePage";
import { CategoryMetaContext, ProviderComparePageContext, useProviderComparePageContext } from "../Context";
import { ProviderCompareNavWithContext } from "../ProviderInfoNav";
import { ProviderCompareInfoWithContext } from "../ProviderInfo";
import { LoadingIndicator } from "../LoadingIndicator";
import { ProviderCompareReportWithContext } from "../ProviderReport";

interface ProviderCompareSelectPageUrlParams {
    from: string;
    to: string;
}

export const ProviderComparePageFragment: React.FC<{}> = () => {
    const { provider, toProvider, metadata } = useProviderComparePageContext();

    const defaultContent = (
        <div className="row">
            <div className="col-12">
                <LoadingIndicator />
            </div>
        </div>
    );

    // const _loading =
    //     loading == null ||
    //     loading === true ||
    //     toProviderLoading == null ||
    //     toProviderLoading === true ||
    //     metadataLoading == null ||
    //     metadataLoading === true;

    // if (_loading) return defaultContent;

    if (!provider || !toProvider || !metadata) return defaultContent;

    return (
        <>
            <div className="row">
                <ProviderCompareNavWithContext />
            </div>
            <div className="row">
                <ProviderCompareInfoWithContext />
            </div>
            <div className="row">
                <ProviderCompareReportWithContext />
            </div>
            <div className="row">
                <ProviderCompareNavWithContext />
            </div>
        </>
    );
};

interface ProviderComparePageProps {
    from?: string;
    to?: string;
}

const LProviderComparePage: React.FC<ProviderComparePageProps> = ({ from, to }) => {
    const { metadata, provider, toProvider, loading, toProviderLoading, metadataLoading, contextType } =
        useProviderComparePage(from, to);

    const locationAdminIds = useMemo(() => {
        return [from, to].filter(d => d != null && d.toString().trim() !== "");
    }, [from, to]);

    const {
        categories,
        roots,
        adminIdToCategory,
        tIdToCategory,
        loading: categoryLoading
    } = useCategory(locationAdminIds, contextType);

    return (
        <ProviderComparePageContext.Provider
            value={{
                metadata,
                provider,
                loading,
                toProvider,
                toProviderLoading,
                metadataLoading,
                contextType
            }}
        >
            <CategoryMetaContext.Provider
                value={{
                    categoryLoading,
                    categories,
                    roots,
                    adminIdToCategory,
                    tIdToCategory
                }}
            >
                <ProviderComparePageFragment />
            </CategoryMetaContext.Provider>
        </ProviderComparePageContext.Provider>
    );
};
export const ProviderComparePage: React.FC<{}> = () => {
    const history = useHistory();
    const { search } = useLocation();

    const urlParams = useMemo(() => {
        if (!search || search.toString().trim() === "") return undefined;

        const params =
            search == null
                ? ({} as ProviderCompareSelectPageUrlParams)
                : (queryString.parse(search) as ProviderCompareSelectPageUrlParams);

        const { from, to } = params ?? {};

        if (from == null || to == null || from.toString().trim() === "" || to.toString().trim() === "") {
            return undefined;
        }

        return {
            from,
            to
        };
    }, [search]);

    if (search == null || search.toString().trim() === "" || urlParams?.from == null || urlParams?.to == null) {
        history.push(`${ROUTE.SEARCH_PAGE}`);
        return null;
    }

    document.title = ROUTE_TITLE.PROVIDER_COMPARE;

    tracker.providerPageNavHistoryIndex = buildUri(
        ROUTE.PROVIDER_COMPARE,
        {},
        {
            from: urlParams.from,
            to: urlParams.to
        }
    );

    return <LProviderComparePage from={urlParams?.from} to={urlParams?.to} />;
};
